/** True when the app is running as an installed PWA (Add to Home Screen / standalone). */
export function isAddToHomeScreen(): boolean {
  if (typeof window === "undefined") return false;
  if (window.matchMedia("(display-mode: standalone)").matches) return true;
  const nav = navigator as Navigator & { standalone?: boolean };
  return Boolean(nav.standalone);
}

export function fetchAuthSession(): Promise<Response> {
  return fetch("/api/auth/session", {
    method: "POST",
    credentials: "same-origin",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ addToHomeScreen: isAddToHomeScreen() }),
  });
}
